/** The 44px minimum tap target the phone apps give every button. Added at the
 *  call site, not in the shared button class, because the desktop tools stay compact. */
export const PHONE_TAP = 'min-h-[44px]'
